angular.module('CarsSaraBo').factory('DateService', ['$filter', function ($filter) {
    return {

        /** PRIVATE METHODS **/

        _isValidDate: function (date) {
            if (date == undefined) {
                return false;
            }
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            return date >= today;
        },

        /** PUBLIC METHODS **/

        customFormatDate: function (date, formatString) {
            if (!formatString) {
                formatString = "dd/MM/yyyy"
            }
            return $filter("date")(date, formatString);
        },

        isValidPeriod: function (period) {
            if (period.from == undefined || period.to == undefined) {
                return false;
            }
            var isValid = true;

            var today = new Date();
            today.setHours(0, 0, 0, 0);
            if (period.from < today || period.to < today) {
                isValid = false;
            }
            if (period.from > period.to) {
                isValid = false;
            }

            return isValid;
        },

        isValidFromDate: function (period) {
            return this._isValidDate(period.from);
        },

        isValidToDate: function (period) {
            if (period.from == undefined || period.to == undefined) {
                return false;
            }
            return (period.from <= period.to);
        },

        periodToDate: function (period) {
            var result = {};
            if (period) {
                try {
                    result.from = this.parseDateString(period.from);
                    result.to = this.parseDateString(period.to);
                    return result;
                } catch (error) {
                    console.error(error);
                }
            }
            return period;
        },

        parseDateString: function (dateString) {
            var pattern = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
            if (pattern.test(dateString)) {
                var values = dateString.split("-");
                var year = values[0];
                var month = values[1] - 1; // ajuste UTC
                var day = values[2];
                return new Date(year, month, day);
            }
            throw 'Invalid date pattern. yyyy-MM-dd expected.';
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/date_service.js
// module id = 844
// module chunks = 3